/**
 * The Validator returns an array of errrors.
 */

const ns = {};

//#region Staff
ns.checkStaff = (rec) =>
{
    let errs = [];
    
    if (!rec.Name)
    {
        errs.push("Please enter a name.");
    }

    if (!rec.Email)
    {
        errs.push("Please enter an email address.");
    }

    if (!rec.ClientMap || !rec.ClientMap.length)
    {
        errs.push("Please select a client for this staff member.");
    }




    return errs;
};
//#endregion




export default ns;